import React, { useCallback, useState } from "react";
import { Autocomplete, createStyles, Select } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import { debounce } from "../../utils/index";

const useStyles = createStyles(() => ({
  row: {
    width: "100%",
  },
  searchbox: {
    width: "100%",
    "& .mantine-Input-input": {
      height: 42,
      minHeight: 42,
      padding: "0 12px 0 38px",
      border: "1px solid #E5E5E5",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter, -apple-system, sans-serif",
      color: "#171717",
      background: "#fff",
      "&:focus": {
        borderColor: "#171717",
        boxShadow: "0 0 0 3px rgba(23,23,23,0.08)",
      },
    },
  },
}));

function BillingSearchBar({
  placeholder,
  data,
  onChange,
  value,
  setValue,
  // setLoading,

  ...props
}) {
  const { classes } = useStyles();

  const debouncedSearch = useCallback(
    debounce((value) => {
      onChange(value);
    }, 700),
    []
  );

  const handleChange = (value) => {
    setValue(value);
    debouncedSearch(value);
    // setLoading(false)
  };

  return (
    <div>
      <div className={classes.row}>
        <Autocomplete
          {...props}
          icon={<IconSearch size={25} />}
          maxDropdownHeight={200}
          rightSectionWidth={30}
          styles={{ rightSection: { pointerEvents: "none" } }}
          className={classes.searchbox}
          placeholder={placeholder}
          data={data}
          value={value}
          onChange={handleChange}
          nothingFound={!value ? null : "No data found"}
          filter={() => true}
          limit={Infinity}
        />
      </div>
    </div>
  );
}

export default BillingSearchBar;
